import React, { useEffect, useState } from "react";
import { League } from "../../types/League";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { LeagueViewTab } from "./MobileLeagues";
import { useUser } from "../../common/contexts/userContext";
import { getLeagueRanking } from "../../services/leagueService";
import { RankingData } from "../../types/RankingData";
import { useAllUsers } from "../../common/contexts/allUsersContext";
import "./LeagueStyles.scss";

interface PersonalLeagueInfoProps {
  leagueInfo: League;
  setManageLeagueId: React.Dispatch<React.SetStateAction<number>>;
  setCurrentView: React.Dispatch<React.SetStateAction<LeagueViewTab>>;
  isAdmin: boolean;
}


const PersonalLeagueInfo: React.FC<PersonalLeagueInfoProps> = ({
  leagueInfo,
  setCurrentView,
  setManageLeagueId,
}) => {
  const { user } = useUser();
  const { users } = useAllUsers();
  const isAdmin = leagueInfo.adminId === user.id;
  const admin = users.filter(item => item.id === leagueInfo.adminId)[0];
  const [dataRows, setDataRows] = useState<RankingData[]>();
  function handleManageLeague() {
    setManageLeagueId(leagueInfo.id);
    setCurrentView("ManageLeagues");
  }
  useEffect(() => {
    getLeagueRanking(leagueInfo.id).then((data) => setDataRows(data.rankingRows));
  }, [leagueInfo]);
  const position = dataRows?.filter((item) => item.userId === user.id)[0]
    ?.rankPlace;

  return (
    <Accordion
      className="personalLeague__accordion"
      disableGutters
      elevation={0}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon className="personalLeague__expandIcon" />}
        aria-controls={`league-${leagueInfo.id}-content`}
        id={`league-${leagueInfo.id}-header`}
        className="personalLeague__summary"
      >
        <div className="personalLeague__summaryInner">
          <Avatar
            src={leagueInfo.leagueImageUrl}
            className="personalLeague__avatar"
          >
            {leagueInfo.name?.charAt(0)}
          </Avatar>
          <span className="personalLeague__name">{leagueInfo.name}</span>
          {position != null && (
            <span className="personalLeague__rankChip">#{position}</span>
          )}
        </div>
      </AccordionSummary>
      <AccordionDetails className="personalLeague__details">
        <div className="personalLeague__statRow">
          <span>Position</span>
          <span className="personalLeague__statValue">{position ?? "—"}</span>
        </div>
        <div className="personalLeague__statRow">
          <span>Players</span>
          <span className="personalLeague__statValue">
            {dataRows?.length ?? "—"}
          </span>
        </div>
        <div className="personalLeague__statRow">
          <span>Admin</span>
          <span className="personalLeague__statValue">{admin?.username}</span>
        </div>

        {isAdmin && (
          <Button
            className="personalLeague__manageBtn"
            onClick={handleManageLeague}
          >
            Manage league
          </Button>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default PersonalLeagueInfo;
